import {
  Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider, FormControl, Paper, TextField
} from '@material-ui/core';
import CropFreeIcon from '@material-ui/icons/CropFree';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { GetWarehouseAddress } from 'src/store/api/Inventory';
import BarkodPopup from '../../components/BarcodePopup';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1)
  },
  fields: {
    margin: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  content: {
    padding: 0
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
}));

function CheckIn(props) {
  const classes = useStyles();
  const [openBarkod, setOpenBarkod] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [MalzemeBarkod, setMalzemeBarkod] = React.useState("");

  const [warehouse, setWarehouse] = useState(0);
  const [warehouses, setWarehouses] = useState([]);

  useEffect(() => {
    GetWarehouseAddress()
      .then(response => {
        setWarehouses(response.data);
      })
  }, []);

  const MalzemeElleEkle = () => {
    handleBarkodClose(MalzemeBarkod);
    setMalzemeBarkod("");
  }
  const BarkodAc = () => {
    if (warehouse === 0) {
      setOpenBarkod(false);
      setUyari("Depo adresi seçiniz!..");
      setOpen(true);
      return;
    }
    setOpenBarkod(true);
  }

  const handleBarkodClose = async (barcode) => {
    setMalzemeBarkod(barcode);
    if (barcode.length === undefined) {
      setMalzemeBarkod("");
      setOpenBarkod(false);
      // setUyari("Barkod okunamadı.Lütfen tekrar deneyiniz!...");
      // setOpen(true);
      return;
    }

    if (barcode.length === 0) {
      setOpenBarkod(false);
      setUyari("Hatalı barkod formatı.Barkod okunamadı.Lütfen tekrar deneyiniz!...");
      setOpen(true);
      return;
    }

    if (warehouse === 0) {
      setOpenBarkod(false);
      setUyari("Depo adresi seçiniz!..");
      setOpen(true);
      return;
    }

    props.SendSetWarehouseInventory(barcode, warehouse);

  }

  return (
    <div>
      <div className={classes.root}>
        <Card>
          <CardHeader title={'Depo Sayım'} />
          <Divider />
          <CardContent className={classes.content}>
            <form
              className={classes.root}>
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Autocomplete
                    options={warehouses}
                    getOptionLabel={(option) => option.Description}
                    onChange={(event, newValue) => newValue ? setWarehouse(newValue.Id) : setWarehouse(0)}
                    renderInput={(params) => <TextField {...params} label="Adres seçiniz!.." variant="outlined" />}
                  />
                </FormControl>
              </div>
              <div className={classes.fields}>
                <Paper
                  className={classes.search}
                  elevation={1}>
                  <CropFreeIcon
                    onClick={BarkodAc}
                    className={classes.searchIcon} />
                  <TextField
                    name="Malzeme"
                    className={classes.searchInput}
                    value={MalzemeBarkod || ''}
                    onChange={event => { setMalzemeBarkod(event.target.value) }}
                    fullWidth
                    placeholder={"Ürün Barkodunu Okutunuz!..."}
                  />
                  <PlaylistAddIcon
                    onClick={MalzemeElleEkle}
                    className={classes.searchIcon} />
                </Paper>

              </div>
            </form>
          </CardContent>
          <BarkodPopup
            onClose={handleBarkodClose}
            open={openBarkod}
            ScanTime={5000}
            CallScreen={1}
          />
        </Card>
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CheckIn;
